var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { gqlSdk } from '@cta-portal/webapp-common/lib/api/client';
import { CardRarity, ImxPendingBurnStatus } from '@cta-portal/webapp-common/lib/api/schema';
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import { ethers } from 'ethers';
import { useContext, useEffect, useState } from 'react';
import { CurrencyContext } from '../../context/currency';
import { DialogContext } from '../../context/dialog';
import { LoadingContext } from '../../context/loading';
import { UserContext } from '../../context/user';
import { CurrencyTokenSymbol } from '../../data/currency-tokens/currency-tokens';
import { appEnv } from '../../env';
import { WalletConnectionType } from '../../types/blockchain';
import { TokenType } from '../../types/common';
import { DialogType } from '../../types/dialogs';
import { sleep } from '../../utils/async';
import { strFloatToTokenQuantity } from '../../utils/blockchain';
import { getAssetFloorPrice } from '../../utils/imx-orders';
import { MAX_SELECTION_COUNT } from '../../utils/multi-select';
import { burnPendingBurn, splitPendingBurns } from '../../utils/pending-burns';
import { useInput } from '../common/use-input';
import { useImxActions } from '../imx/use-imx-actions';
export function useMultipleAssets(allAssets, refreshAssets) {
    var t = useI18n().t;
    var setImxLoading = useContext(LoadingContext).setImxLoading;
    var setDialogProps = useContext(DialogContext).setDialogProps;
    var _a = useContext(UserContext), user = _a.user, fees = _a.fees, selectedWallet = _a.selectedWallet, reconnectUser = _a.reconnectUser;
    var _b = useContext(CurrencyContext), imxClient = _b.imxClient, tokens = _b.tokens, usdcAddress = _b.usdcAddress, queue = _b.queue, parseCurrencyQuantity = _b.parseCurrencyQuantity;
    var imxActions = useImxActions();
    var _c = useState([]), selectedAssets = _c[0], setSelectedAssets = _c[1];
    var _d = useState([]), lastSelectedAssetIndexes = _d[0], setLastSelectedAssetIndexes = _d[1];
    var _e = useState(0), maxCountToSelect = _e[0], setMaxCountToSelect = _e[1];
    var walletToTransferAddress = useInput('');
    var _f = useState(CurrencyTokenSymbol.USDC), listForSaleCurrencyTokenSymbol = _f[0], setListForSaleCurrencyTokenSymbol = _f[1];
    var listForSalePrice = useInput('');
    var _g = useState(undefined), selectedTokenId = _g[0], setSelectedTokenId = _g[1];
    useEffect(function () {
        if (selectedAssets.length > 0) {
            unselectedAllAssets();
        }
        setMaxCountToSelect(Math.min(MAX_SELECTION_COUNT, allAssets.length));
    }, [allAssets]);
    useEffect(function () {
        unselectedAllAssets();
    }, [selectedWallet]);
    useEffect(function () {
        var invalidAddress = walletToTransferAddress.value.length === 0 ? false : !ethers.isAddress(walletToTransferAddress.value);
        setDialogProps(function (value) {
            if ((value === null || value === void 0 ? void 0 : value.custom.type) === DialogType.TRANSFER_ASSET) {
                return {
                    common: __assign(__assign({}, value.common), { actions: [
                            {
                                highlighted: true,
                                text: t('common.confirm'),
                                action: value.custom.multiple
                                    ? function () { return transferMultipleAssets(walletToTransferAddress); }
                                    : function () { return transferSingleAsset(selectedTokenId, walletToTransferAddress); },
                                disabled: walletToTransferAddress.value.length === 0 || invalidAddress,
                            },
                        ] }),
                    custom: __assign(__assign({}, value.custom), { walletToAddress: walletToTransferAddress, invalidAddress: invalidAddress }),
                };
            }
            return value;
        });
    }, [walletToTransferAddress.value, selectedTokenId]);
    useEffect(function () {
        setDialogProps(function (value) {
            return (value === null || value === void 0 ? void 0 : value.custom.type) === DialogType.LIST_FOR_SALE_SINGLE
                ? {
                    common: __assign(__assign({}, value.common), { actions: [
                            {
                                highlighted: true,
                                text: t('common.confirm'),
                                action: function () { return listForSaleSingle(selectedTokenId, listForSalePrice, listForSaleCurrencyTokenSymbol); },
                                disabled: listForSalePrice.value.length === 0 || Number.parseFloat(listForSalePrice.value) === 0,
                            },
                        ] }),
                    custom: __assign(__assign({}, value.custom), { currencyTokenSymbol: listForSaleCurrencyTokenSymbol, price: listForSalePrice }),
                }
                : value;
        });
    }, [listForSaleCurrencyTokenSymbol, listForSalePrice.value, selectedTokenId]);
    useEffect(function () {
        setDialogProps(function (value) {
            return (value === null || value === void 0 ? void 0 : value.custom.type) === DialogType.LIST_FOR_SALE_MULTIPLE
                ? {
                    common: __assign(__assign({}, value.common), { actions: [
                            {
                                highlighted: true,
                                text: t('common.confirm'),
                                action: function () { return listForSaleMultiple(listForSalePrice, listForSaleCurrencyTokenSymbol); },
                                disabled: listForSalePrice.value.length === 0 || Number.parseFloat(listForSalePrice.value) === 0,
                            },
                        ] }),
                    custom: __assign(__assign({}, value.custom), { currencyTokenSymbol: listForSaleCurrencyTokenSymbol, price: listForSalePrice }),
                }
                : value;
        });
    }, [listForSaleCurrencyTokenSymbol, listForSalePrice.value, selectedTokenId]);
    useEffect(function () {
        setDialogProps(function (value) {
            return (value === null || value === void 0 ? void 0 : value.custom.type) === DialogType.LIST_FOR_SALE_SINGLE
                ? {
                    common: __assign(__assign({}, value.common), { actions: [
                            {
                                highlighted: true,
                                text: t('common.confirm'),
                                disabled: true,
                            },
                        ] }),
                    custom: __assign(__assign({}, value.custom), { currencyTokenSymbol: listForSaleCurrencyTokenSymbol, price: __assign(__assign({}, listForSalePrice), { value: '' }) }),
                }
                : value;
        });
        listForSalePrice.setValue('');
    }, [listForSaleCurrencyTokenSymbol]);
    function selectAsset(index) {
        if (!allAssets[index])
            return;
        var values = __spreadArray([], selectedAssets, true);
        var selectedIndexes = __spreadArray([], lastSelectedAssetIndexes, true);
        var foundIndex = values.findIndex(function (value) { return value.asset.token_id === allAssets[index].asset.token_id; });
        if (foundIndex === -1) {
            values.push(allAssets[index]);
            selectedIndexes.push(index);
        }
        else {
            values.splice(foundIndex, 1);
            selectedIndexes.splice(index, 1);
        }
        setSelectedAssets(values);
        setLastSelectedAssetIndexes(selectedIndexes);
    }
    function shiftSelectAsset(index) {
        if (!allAssets[index])
            return;
        var values = __spreadArray([], selectedAssets, true);
        var selectedIndexes = __spreadArray([], lastSelectedAssetIndexes, true);
        var lastIndex = lastSelectedAssetIndexes.length === 0 ? -1 : lastSelectedAssetIndexes[lastSelectedAssetIndexes.length - 1];
        if (lastIndex === -1 || lastIndex === index) {
            selectAsset(index);
            return;
        }
        var startIndex = lastIndex > index ? index : lastIndex;
        var endIndex = lastIndex > index ? lastIndex : index;
        var _loop_1 = function (i) {
            var findIndex = values.findIndex(function (value) { return value.asset.token_id === allAssets[i].asset.token_id; });
            if (findIndex === -1) {
                values.push(allAssets[i]);
            }
        };
        for (var i = startIndex; i <= endIndex; i++) {
            _loop_1(i);
        }
        selectedIndexes.push(index);
        setSelectedAssets(values);
        setLastSelectedAssetIndexes(selectedIndexes);
    }
    function changeAssetsSelection(count) {
        var values = [];
        var selectedIndexes = [];
        for (var i = 0; i < count; i++) {
            values.push(allAssets[i]);
        }
        setSelectedAssets(values);
        setLastSelectedAssetIndexes(selectedIndexes);
    }
    function selectAllOrders() {
        if (selectedAssets.length === allAssets.length) {
            setSelectedAssets([]);
        }
        else {
            setSelectedAssets(__spreadArray([], allAssets, true));
        }
        setLastSelectedAssetIndexes([]);
    }
    function unselectedAllAssets() {
        setSelectedAssets([]);
    }
    function showTransferSingleAssetsDialog(tokenId) {
        setSelectedTokenId(tokenId);
        setDialogProps({
            common: {
                title: t('common.transfer'),
                close: { text: t('common.cancel'), action: hideDialog },
                actions: [{ highlighted: true, text: t('common.confirm'), disabled: true }],
            },
            custom: {
                type: DialogType.TRANSFER_ASSET,
                walletToAddress: walletToTransferAddress,
                invalidAddress: false,
            },
        });
    }
    function transferSingleAsset(tokenId, toAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var error, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!tokenId || !selectedWallet)
                            return [2 /*return*/];
                        setImxLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, imxActions.transferERC721({
                                walletFrom: selectedWallet,
                                toAddress: toAddress.value,
                                tokenIds: [tokenId],
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        if (err_1 instanceof Error) {
                            if (err_1.message.includes('USER_VERIFIED_REQUIRED')) {
                                error = t('error.imx.kyc-required');
                            }
                            else if (err_1.message.includes('MPC_WALLET_CTA_TOKEN_IS_LOCKED')) {
                                error = t('error.imx.cta-token-locked');
                            }
                            else if (err_1.message.includes('MPC_WALLET_ASSET_IS_LOCKED')) {
                                error = t('error.imx.asset-locked');
                            }
                            else {
                                error = t('error.generic');
                            }
                            console.log("[transferSingleAssets] ".concat(err_1));
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        if (!!error) return [3 /*break*/, 7];
                        return [4 /*yield*/, sleep(4000)];
                    case 5:
                        _a.sent();
                        return [4 /*yield*/, refreshAssets()];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7:
                        setImxLoading(false);
                        setDialogProps({
                            common: {
                                title: error ? t('common.error') : t('common.success'),
                                close: { text: t('common.back'), action: hideDialog },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error || t('transfer-asset.single.success-message'),
                            },
                        });
                        return [2 /*return*/];
                }
            });
        });
    }
    function showTransferMultipleAssetsDialog() {
        setDialogProps({
            common: {
                title: t('common.transfer'),
                close: { text: t('common.cancel'), action: hideDialog },
                actions: [{ highlighted: true, text: t('common.confirm'), disabled: true }],
            },
            custom: {
                type: DialogType.TRANSFER_ASSET,
                walletToAddress: walletToTransferAddress,
                invalidAddress: false,
                multiple: true,
            },
        });
    }
    function transferMultipleAssets(toAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var error, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!selectedWallet)
                            return [2 /*return*/];
                        setImxLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, imxActions.transferERC721({
                                walletFrom: selectedWallet,
                                toAddress: toAddress.value,
                                tokenIds: selectedAssets.map(function (asset) { return asset.asset.token_id; }),
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _a.sent();
                        if (err_2 instanceof Error) {
                            if (err_2.message.includes('USER_VERIFIED_REQUIRED')) {
                                error = t('error.imx.kyc-required');
                            }
                            else if (err_2.message.includes('MPC_WALLET_CTA_TOKEN_IS_LOCKED')) {
                                error = t('error.imx.cta-token-locked');
                            }
                            else if (err_2.message.includes('MPC_WALLET_ASSET_IS_LOCKED')) {
                                error = t('error.imx.asset-locked');
                            }
                            else {
                                error = t('error.generic');
                            }
                            console.log("[transferMultipleAssets] ".concat(err_2));
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        if (!!error) return [3 /*break*/, 7];
                        return [4 /*yield*/, sleep(4000)];
                    case 5:
                        _a.sent();
                        return [4 /*yield*/, refreshAssets()];
                    case 6:
                        _a.sent();
                        unselectedAllAssets();
                        _a.label = 7;
                    case 7:
                        setImxLoading(false);
                        setDialogProps({
                            common: {
                                title: error ? t('common.error') : t('common.success'),
                                close: { text: t('common.back'), action: hideDialog },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error || t('transfer-asset.multiple.success-message'),
                            },
                        });
                        return [2 /*return*/];
                }
            });
        });
    }
    function showListForSaleSingleDialog(asset, shredStonesCount) {
        return __awaiter(this, void 0, void 0, function () {
            var assetMetadata, metadata, floorPrice;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!imxClient || !usdcAddress || !fees)
                            return [2 /*return*/];
                        setSelectedTokenId(asset.token_id);
                        setDialogProps({
                            common: {
                                title: t('common.list-for-sale'),
                                close: { text: t('common.cancel'), action: hideDialog },
                                actions: [{ highlighted: true, text: t('common.confirm'), disabled: true }],
                            },
                            custom: {
                                type: DialogType.LIST_FOR_SALE_SINGLE,
                                currencyTokenSymbol: listForSaleCurrencyTokenSymbol,
                                setCurrencyTokenSymbol: setListForSaleCurrencyTokenSymbol,
                                price: listForSalePrice,
                                shredStonesCount: shredStonesCount,
                                floorPriceLoading: true,
                            },
                        });
                        assetMetadata = asset.metadata;
                        metadata = {
                            ian: assetMetadata.ian,
                            id: assetMetadata.id,
                            name: asset.name || undefined,
                            rarity: assetMetadata.rarity,
                            element: assetMetadata.element,
                            grades: assetMetadata.grade ? [assetMetadata.grade] : undefined,
                            ranks: assetMetadata.rank ? [assetMetadata.rank] : undefined,
                            foil: assetMetadata.foil,
                        };
                        return [4 /*yield*/, getAssetFloorPrice(imxClient, usdcAddress, queue, fees, parseCurrencyQuantity, assetMetadata.tokenType, metadata)];
                    case 1:
                        floorPrice = _b.sent();
                        setDialogProps({
                            common: {
                                title: t('common.list-for-sale'),
                                close: { text: t('common.cancel'), action: hideDialog },
                                actions: [{ highlighted: true, text: t('common.confirm'), disabled: true }],
                            },
                            custom: {
                                type: DialogType.LIST_FOR_SALE_SINGLE,
                                currencyTokenSymbol: listForSaleCurrencyTokenSymbol,
                                setCurrencyTokenSymbol: setListForSaleCurrencyTokenSymbol,
                                price: listForSalePrice,
                                usdFloorPrice: (_a = floorPrice === null || floorPrice === void 0 ? void 0 : floorPrice.price.usd) === null || _a === void 0 ? void 0 : _a.displayValue,
                                shredStonesCount: shredStonesCount,
                                floorPriceLoading: false,
                            },
                        });
                        return [2 /*return*/];
                }
            });
        });
    }
    function listForSaleSingle(tokenId, price, symbol) {
        return __awaiter(this, void 0, void 0, function () {
            var error, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!tokens || !usdcAddress || !tokenId || !selectedWallet)
                            return [2 /*return*/];
                        setImxLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, imxActions.listForSale({
                                walletFrom: selectedWallet,
                                sellTokenId: tokenId,
                                buyQuantity: strFloatToTokenQuantity(price.value, tokens, symbol === CurrencyTokenSymbol.CTA ? appEnv.ctaTokenAddress : usdcAddress),
                                buyTokenAddress: symbol === CurrencyTokenSymbol.CTA ? appEnv.ctaTokenAddress : usdcAddress,
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_3 = _a.sent();
                        console.error(err_3);
                        if (err_3 instanceof Error) {
                            if (err_3.message.includes('USER_VERIFIED_REQUIRED')) {
                                error = t('error.imx.kyc-required');
                            }
                            else if (err_3.message.includes('MPC_WALLET_CTA_TOKEN_IS_LOCKED')) {
                                error = t('error.imx.cta-token-locked');
                            }
                            else if (err_3.message.includes('MPC_WALLET_ASSET_IS_LOCKED')) {
                                error = t('error.imx.asset-locked');
                            }
                            else {
                                error = t('error.generic');
                            }
                            console.log("[listForSaleSingle] ".concat(err_3));
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        if (!!error) return [3 /*break*/, 7];
                        return [4 /*yield*/, sleep(4000)];
                    case 5:
                        _a.sent();
                        return [4 /*yield*/, refreshAssets()];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7:
                        setDialogProps({
                            common: {
                                title: error ? t('common.error') : t('common.list-for-sale'),
                                close: { text: t('common.back'), action: hideDialog },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error || t('list-for-sale.single.success-message'),
                            },
                        });
                        setImxLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    function showListForSaleMultipleDialog() {
        setDialogProps({
            common: {
                title: t('common.list-for-sale'),
                close: { text: t('common.cancel'), action: hideDialog },
                actions: [{ highlighted: true, text: t('common.confirm'), disabled: true }],
            },
            custom: {
                type: DialogType.LIST_FOR_SALE_MULTIPLE,
                currencyTokenSymbol: listForSaleCurrencyTokenSymbol,
                setCurrencyTokenSymbol: setListForSaleCurrencyTokenSymbol,
                price: listForSalePrice,
            },
        });
    }
    function listForSaleMultiple(price, symbol) {
        return __awaiter(this, void 0, void 0, function () {
            var error, _i, selectedAssets_1, asset, err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!tokens || !usdcAddress || !selectedWallet)
                            return [2 /*return*/];
                        setImxLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        _i = 0, selectedAssets_1 = selectedAssets;
                        _a.label = 2;
                    case 2:
                        if (!(_i < selectedAssets_1.length)) return [3 /*break*/, 5];
                        asset = selectedAssets_1[_i];
                        return [4 /*yield*/, imxActions.listForSale({
                                walletFrom: selectedWallet,
                                sellTokenId: asset.asset.token_id,
                                buyQuantity: strFloatToTokenQuantity(price.value, tokens, symbol === CurrencyTokenSymbol.CTA ? appEnv.ctaTokenAddress : usdcAddress),
                                buyTokenAddress: symbol === CurrencyTokenSymbol.CTA ? appEnv.ctaTokenAddress : usdcAddress,
                            })];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        err_4 = _a.sent();
                        console.error(err_4);
                        if (err_4 instanceof Error) {
                            if (err_4.message.includes('USER_VERIFIED_REQUIRED')) {
                                error = t('error.imx.kyc-required');
                            }
                            else if (err_4.message.includes('MPC_WALLET_CTA_TOKEN_IS_LOCKED')) {
                                error = t('error.imx.cta-token-locked');
                            }
                            else if (err_4.message.includes('MPC_WALLET_ASSET_IS_LOCKED')) {
                                error = t('error.imx.asset-locked');
                            }
                            else {
                                error = t('error.generic');
                            }
                            console.log("[listForSaleMultiple] ".concat(err_4));
                        }
                        return [3 /*break*/, 7];
                    case 7:
                        if (!!error) return [3 /*break*/, 10];
                        return [4 /*yield*/, sleep(4000)];
                    case 8:
                        _a.sent();
                        return [4 /*yield*/, refreshAssets()];
                    case 9:
                        _a.sent();
                        unselectedAllAssets();
                        _a.label = 10;
                    case 10:
                        setDialogProps({
                            common: {
                                title: error ? t('common.error') : t('common.list-for-sale'),
                                close: { text: t('common.back'), action: hideDialog },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error || t('list-for-sale.multiple.success-message'),
                            },
                        });
                        setImxLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    function showCancelListingDialog(orderId) {
        if (!orderId)
            return;
        setDialogProps({
            common: {
                title: t('common.cancel-listing'),
                close: { text: t('common.cancel'), action: function () { return setDialogProps(undefined); } },
                actions: [{ highlighted: true, text: t('common.confirm'), action: function () { return cancelListing(orderId); } }],
            },
            custom: {
                type: DialogType.SIMPLE,
                message: t('cancel-listing.single.message'),
            },
        });
    }
    function cancelListing(orderId) {
        return __awaiter(this, void 0, void 0, function () {
            var error, err_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!selectedWallet)
                            return [2 /*return*/];
                        setImxLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, imxActions.cancelOrder({ walletFrom: selectedWallet, orderId: orderId })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_5 = _a.sent();
                        if (err_5 instanceof Error) {
                            if (err_5.message.includes('USER_VERIFIED_REQUIRED')) {
                                error = t('error.imx.kyc-required');
                            }
                            else if (err_5.message.includes('MPC_WALLET_CTA_TOKEN_IS_LOCKED')) {
                                error = t('error.imx.cta-token-locked');
                            }
                            else if (err_5.message.includes('MPC_WALLET_ASSET_IS_LOCKED')) {
                                error = t('error.imx.asset-locked');
                            }
                            else {
                                error = t('error.generic');
                            }
                            console.log("[cancelListing] ".concat(err_5));
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        if (!!error) return [3 /*break*/, 7];
                        return [4 /*yield*/, sleep(4000)];
                    case 5:
                        _a.sent();
                        return [4 /*yield*/, refreshAssets()];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7:
                        setImxLoading(false);
                        setDialogProps({
                            common: {
                                title: error ? t('common.error') : t('common.cancel-listing'),
                                close: { text: t('common.back'), action: hideDialog },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error || t('cancel-listing.single.success-message'),
                            },
                        });
                        return [2 /*return*/];
                }
            });
        });
    }
    function showShredSingleAssetDialog(tokenId) {
        var asset = allAssets.find(function (asset) { return asset.asset.token_id === tokenId; });
        if (!tokenId || !asset || !asset.shredPreview)
            return;
        setDialogProps({
            common: {
                title: t('common.shred'),
                close: { text: t('common.cancel'), action: function () { return setDialogProps(undefined); } },
                actions: [{ highlighted: true, text: t('common.confirm'), action: function () { return shredSingleAsset(tokenId); } }],
            },
            custom: {
                type: DialogType.SHRED,
                stonesCount: asset.shredPreview.stonesCount,
                triselsCount: asset.shredPreview.triselsCount,
            },
        });
    }
    function shredSingleAsset(tokenId) {
        return __awaiter(this, void 0, void 0, function () {
            var error, pendingBurn, result, _a, blockchainPendingBurnFindOneWithEmail, _b, magicLink, metamask, mpc, burnCompleted, burnResult;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        setImxLoading(true);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, gqlSdk.CardDisenchantCards({
                                input: {
                                    cardUuids: [],
                                    tokenIds: [Number.parseInt(tokenId)],
                                },
                            })];
                    case 2:
                        result = _c.sent();
                        pendingBurn = result.cardDisenchantCards.pendingBurn;
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _c.sent();
                        error = t('error.generic');
                        return [3 /*break*/, 4];
                    case 4:
                        if (!pendingBurn) return [3 /*break*/, 16];
                        return [4 /*yield*/, gqlSdk.BlockchainPendingBurnFindOneWithEmail({
                                input: { pendingBurnUuid: pendingBurn.uuid },
                            })];
                    case 5:
                        blockchainPendingBurnFindOneWithEmail = (_c.sent()).blockchainPendingBurnFindOneWithEmail;
                        _b = splitPendingBurns(blockchainPendingBurnFindOneWithEmail.pendingBurn.tokenIdsToBurn), magicLink = _b.magicLink, metamask = _b.metamask, mpc = _b.mpc;
                        if (!(magicLink.ids.length > 0)) return [3 /*break*/, 7];
                        return [4 /*yield*/, burnPendingBurn(imxActions, magicLink.address, magicLink.ids, WalletConnectionType.MAGIC_LINK, (user === null || user === void 0 ? void 0 : user.email) || '', (user === null || user === void 0 ? void 0 : user.magicLinkWalletAddress) || undefined)];
                    case 6:
                        _c.sent();
                        _c.label = 7;
                    case 7:
                        if (!(metamask.ids.length > 0)) return [3 /*break*/, 9];
                        return [4 /*yield*/, burnPendingBurn(imxActions, metamask.address, metamask.ids, WalletConnectionType.METAMASK, (user === null || user === void 0 ? void 0 : user.email) || '', (user === null || user === void 0 ? void 0 : user.magicLinkWalletAddress) || undefined)];
                    case 8:
                        _c.sent();
                        _c.label = 9;
                    case 9:
                        if (!(mpc.ids.length > 0)) return [3 /*break*/, 11];
                        return [4 /*yield*/, burnPendingBurn(imxActions, mpc.address, mpc.ids, WalletConnectionType.MPC, (user === null || user === void 0 ? void 0 : user.email) || '', (user === null || user === void 0 ? void 0 : user.magicLinkWalletAddress) || undefined)];
                    case 10:
                        _c.sent();
                        _c.label = 11;
                    case 11:
                        burnCompleted = false;
                        _c.label = 12;
                    case 12: return [4 /*yield*/, gqlSdk.BlockchainPendingBurnFindOne({
                            input: { pendingBurnUuid: pendingBurn.uuid },
                        })];
                    case 13:
                        burnResult = _c.sent();
                        burnCompleted = burnResult.blockchainPendingBurnFindOne.status === ImxPendingBurnStatus.COMPLETED;
                        if (!!burnCompleted) return [3 /*break*/, 15];
                        return [4 /*yield*/, sleep(1000)];
                    case 14:
                        _c.sent();
                        _c.label = 15;
                    case 15:
                        if (!burnCompleted) return [3 /*break*/, 12];
                        _c.label = 16;
                    case 16: return [4 /*yield*/, Promise.all([reconnectUser(), refreshAssets()])];
                    case 17:
                        _c.sent();
                        setImxLoading(false);
                        setDialogProps({
                            common: {
                                title: error ? t('common.error') : t('common.shred'),
                                close: { text: t('common.back'), action: hideDialog },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error || t('shred.single.success-message'),
                            },
                        });
                        return [2 /*return*/];
                }
            });
        });
    }
    function showShredMultipleAssetDialog() {
        var shredPreview = { stonesCount: 0, triselsCount: 0 };
        for (var _i = 0, selectedAssets_2 = selectedAssets; _i < selectedAssets_2.length; _i++) {
            var asset = selectedAssets_2[_i];
            if (asset.shredPreview) {
                shredPreview.stonesCount += asset.shredPreview.stonesCount;
                shredPreview.triselsCount += asset.shredPreview.triselsCount;
            }
        }
        setDialogProps({
            common: {
                title: t('common.shred'),
                close: { text: t('common.cancel'), action: function () { return setDialogProps(undefined); } },
                actions: [{ highlighted: true, text: t('common.confirm'), action: shredMultipleAssets }],
            },
            custom: {
                type: DialogType.SHRED,
                stonesCount: shredPreview.stonesCount,
                triselsCount: shredPreview.triselsCount,
                multiple: true,
            },
        });
    }
    function shredMultipleAssets() {
        return __awaiter(this, void 0, void 0, function () {
            var error, pendingBurn, result, _a, blockchainPendingBurnFindOneWithEmail, _b, magicLink, metamask, mpc, burnCompleted, burnResult;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        setImxLoading(true);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, gqlSdk.CardDisenchantCards({
                                input: {
                                    cardUuids: [],
                                    tokenIds: selectedAssets.map(function (asset) { return Number.parseInt(asset.asset.token_id); }),
                                },
                            })];
                    case 2:
                        result = _c.sent();
                        pendingBurn = result.cardDisenchantCards.pendingBurn;
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _c.sent();
                        error = t('error.generic');
                        return [3 /*break*/, 4];
                    case 4:
                        if (!pendingBurn) return [3 /*break*/, 16];
                        return [4 /*yield*/, gqlSdk.BlockchainPendingBurnFindOneWithEmail({
                                input: { pendingBurnUuid: pendingBurn.uuid },
                            })];
                    case 5:
                        blockchainPendingBurnFindOneWithEmail = (_c.sent()).blockchainPendingBurnFindOneWithEmail;
                        _b = splitPendingBurns(blockchainPendingBurnFindOneWithEmail.pendingBurn.tokenIdsToBurn), magicLink = _b.magicLink, metamask = _b.metamask, mpc = _b.mpc;
                        if (!(magicLink.ids.length > 0)) return [3 /*break*/, 7];
                        return [4 /*yield*/, burnPendingBurn(imxActions, magicLink.address, magicLink.ids, WalletConnectionType.MAGIC_LINK, (user === null || user === void 0 ? void 0 : user.email) || '', (user === null || user === void 0 ? void 0 : user.magicLinkWalletAddress) || undefined)];
                    case 6:
                        _c.sent();
                        _c.label = 7;
                    case 7:
                        if (!(metamask.ids.length > 0)) return [3 /*break*/, 9];
                        return [4 /*yield*/, burnPendingBurn(imxActions, metamask.address, metamask.ids, WalletConnectionType.METAMASK, (user === null || user === void 0 ? void 0 : user.email) || '', (user === null || user === void 0 ? void 0 : user.magicLinkWalletAddress) || undefined)];
                    case 8:
                        _c.sent();
                        _c.label = 9;
                    case 9:
                        if (!(mpc.ids.length > 0)) return [3 /*break*/, 11];
                        return [4 /*yield*/, burnPendingBurn(imxActions, mpc.address, mpc.ids, WalletConnectionType.MPC, (user === null || user === void 0 ? void 0 : user.email) || '', (user === null || user === void 0 ? void 0 : user.magicLinkWalletAddress) || undefined)];
                    case 10:
                        _c.sent();
                        _c.label = 11;
                    case 11:
                        burnCompleted = false;
                        _c.label = 12;
                    case 12: return [4 /*yield*/, gqlSdk.BlockchainPendingBurnFindOne({
                            input: { pendingBurnUuid: pendingBurn.uuid },
                        })];
                    case 13:
                        burnResult = _c.sent();
                        burnCompleted = burnResult.blockchainPendingBurnFindOne.status === ImxPendingBurnStatus.COMPLETED;
                        if (!!burnCompleted) return [3 /*break*/, 15];
                        return [4 /*yield*/, sleep(1000)];
                    case 14:
                        _c.sent();
                        _c.label = 15;
                    case 15:
                        if (!burnCompleted) return [3 /*break*/, 12];
                        _c.label = 16;
                    case 16: return [4 /*yield*/, Promise.all([reconnectUser(), refreshAssets()])];
                    case 17:
                        _c.sent();
                        unselectedAllAssets();
                        setImxLoading(false);
                        setDialogProps({
                            common: {
                                title: error ? t('common.error') : t('common.shred'),
                                close: { text: t('common.back'), action: hideDialog },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error || t('shred.multiple.success-message'),
                            },
                        });
                        return [2 /*return*/];
                }
            });
        });
    }
    function hideDialog() {
        walletToTransferAddress.setValue('');
        listForSalePrice.setValue('');
        setListForSaleCurrencyTokenSymbol(CurrencyTokenSymbol.USDC);
        setSelectedTokenId(undefined);
        setDialogProps(undefined);
    }
    function isSelectionContainingOnSale() {
        return selectedAssets.some(function (asset) { return asset.orderId !== undefined; });
    }
    function isMultipleShredDisabled() {
        return selectedAssets.some(function (asset) {
            var metadata = asset.asset.metadata;
            return (asset.tokenType !== TokenType.CARD ||
                (metadata === null || metadata === void 0 ? void 0 : metadata.rarity) === CardRarity.EXCLUSIVE ||
                (metadata === null || metadata === void 0 ? void 0 : metadata.rarity) === CardRarity.UNIQUE);
        });
    }
    return {
        selectedAssetIds: selectedAssets.map(function (asset) { return asset.asset.token_id.toString(); }),
        multipleShredDisabled: isMultipleShredDisabled(),
        selectionContainsOnSale: isSelectionContainingOnSale(),
        maxCountToSelect: maxCountToSelect,
        selectAsset: selectAsset,
        shiftSelectAsset: shiftSelectAsset,
        changeAssetsSelection: changeAssetsSelection,
        selectAllOrders: selectAllOrders,
        unselectedAllAssets: unselectedAllAssets,
        showTransferSingleAssetsDialog: showTransferSingleAssetsDialog,
        showTransferMultipleAssetsDialog: showTransferMultipleAssetsDialog,
        showListForSaleSingleDialog: showListForSaleSingleDialog,
        showListForSaleMultipleDialog: showListForSaleMultipleDialog,
        showCancelListingDialog: showCancelListingDialog,
        showShredSingleAssetDialog: showShredSingleAssetDialog,
        showShredMultipleAssetDialog: showShredMultipleAssetDialog,
    };
}
